import { Box, Paper } from '@mui/material';
import { CashToCloseData } from 'hooks/useGetCashToClose/types';
import React, { ReactNode } from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { useStyles } from '../../styles';
import { CashToCloseEntryRow } from '../../types';
import { Description } from '../description';
import { ChangeFields, EstimateAmountField, FinalAmountField } from './fields';

type MobileCardProps = {
  row: CashToCloseEntryRow,
  children: ReactNode
}

type Props = {
  dataSet: CashToCloseEntryRow[],
  footerDataSet: CashToCloseEntryRow[],
  control: Control<CashToCloseData, object>,
  watch: UseFormWatch<CashToCloseData>,
  setValue: UseFormSetValue<CashToCloseData>,
  isUpdateLoading: boolean
}

const MobileCard = ({ row, children }: MobileCardProps) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" role="group" aria-label={row.title} className={classes.mobileCard}>
      <Description text={row.title} className={classes.mobileTitle} />
      {children}
    </Paper>
  );
};

export const MobileCashToCloseCards = ({
  dataSet,
  footerDataSet,
  control,
  watch,
  setValue,
  isUpdateLoading
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.mobileList}>
      {dataSet.map((row) => (
        <MobileCard key={row.fieldName} row={row}>
          <EstimateAmountField
            row={row}
            control={control}
            watch={watch}
            isUpdateLoading={isUpdateLoading}
          />
          <FinalAmountField row={row} control={control} />
          <ChangeFields
            row={row}
            control={control}
            watch={watch}
            setValue={setValue}
            isUpdateLoading={isUpdateLoading}
          />
        </MobileCard>
      ))}

      {footerDataSet.map((row) => (
        <MobileCard key={row.fieldName} row={row}>
          <FinalAmountField row={row} control={control} />
        </MobileCard>
      ))}
    </Box>
  );
};
